import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate'
import moment from 'moment'

Vue.use(VueAxios, axios)

VeeValidate.Validator.extend('is_time', {
	getMessage: field => 'Il formato deve essere HH:MM',
	validate: (value) => new Promise(resolve => {
		let regex = new RegExp('([0-1][0-9]|2[0-3]):([0-5][0-9])')
		resolve({
			valid: value && regex.test(value)
		})
	}),
})

VeeValidate.Validator.extend('is_time_correct', {
	getMessage: field => 'L\'orario non è corretto',
	validate: (value, args) => {
		if(moment(value, 'HH:mm').isBefore(moment(args[0], 'HH:mm'))) {
			return false
		}else{
			return true
		}		
	},
	hasTarget: true
})